<script>
    import { createEventDispatcher } from 'svelte';

    // Declare the dispatcher
    const dispatch = createEventDispatcher();

    //PROPS
    export let image = '';
    export let skipUploadText = '';
    export let alt = '';

    //METHODS
    function fileSelected(e) {
        let file = e.target.files[0];
        let reader = new FileReader();

        reader.readAsDataURL(file);
        reader.onload = e => {
            alt = file.name;
            image = e.target.result;
            dispatch('image', image);
        };
    }
    function skip() {
        dispatch('skip');
    }

</script>

<!-- ======================== HTML TEMPLATE ================================= -->
<div class="app-msi_flex-column app-msi_align-items-center">
    <p>
        <input
            accept="image/png, image/jpeg"
            type="file"
            id="msi-photo"
            name="photo"
            on:change={e => fileSelected(e)}
        />
        <label class="app-msi_file" for="msi-photo"></label>
    </p>
    {#if (image)}
        <img src="{image}" class="app-msi_file-image" alt="{alt}" />
    {:else}
    <p>
        <a href={"#"} on:click|preventDefault={() => skip()}>
            <em>{skipUploadText}</em>
        </a>
    </p>
    {/if}
</div>

<style scoped>
    .app-msi_file-image {
        max-height: 250px;
        max-width: 100%;
    }
</style>
